import { Component, OnInit } from '@angular/core';
import { DataprofileService } from '../service/dataprofile.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Profile } from '../model/profile.model';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-duplicate-profile-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatCardModule
  ],
  templateUrl: './duplicate-profile-dialog.component.html',
  styleUrl: './duplicate-profile-dialog.component.scss'
})
export class DuplicateProfileDialogComponent implements OnInit {

  form = new FormGroup({
    profilelist: new FormControl<number | null>(null),
    name: new FormControl('', Validators.required),
    description: new FormControl('', Validators.required)
  });

  profilelist: Profile[] = [];
  isProfileSelected = false;
  selectedProfile: Profile | null = null;


  constructor(
    private dataProfileService: DataprofileService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<DuplicateProfileDialogComponent>
  ) {}


  ngOnInit(): void {
    this.getProfiles();
  }


  getProfiles(): void {
    this.dataProfileService.getProfiles().subscribe(profiles => {
      this.profilelist = profiles;
    });
  }


  onProfileChange(event: any): void {

    const selectedProfileId = event.value;

    if (selectedProfileId === null) {
      this.form.patchValue({
        name: '',
        description: ''
      });

      this.selectedProfile = null;
      this.isProfileSelected = false;
      return;
    }


    this.selectedProfile = this.profilelist.find(
      profile => profile.id === selectedProfileId
    ) || null;


    if (this.selectedProfile) {
      this.form.patchValue({
        name: '',
        description: `Copied from source profile: ${this.selectedProfile.description}` 
      });

      this.isProfileSelected = true;
    }
  }


  duplicateProfile(): void {

    if (this.form.invalid || !this.selectedProfile) {
      return;
    }


    const profileName = this.form.get('name')?.value;


    this.dataProfileService
      .duplicateDataProfile(this.selectedProfile, profileName!)
      .subscribe({
        next: (res) => {

          this.snackBar.open(
            `${res} is successfully created.`,
            'OK',
            { duration: 3000 }
          );

          // close dialog and return success
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error(err);
        }
      });
  }


  clear(): void {
    this.form.reset();
  }

}